/**
 * Стаб для `virtual:pwa-register` — используется на dashboard-сборке,
 * где VitePWA НЕ подключён (SW на дашборде вызывает проблемы с кэшем
 * старых chunk-хешей, см. vite.config.ts).
 *
 * Помимо no-op, выполняет kill-switch: разрегистрирует любой SW который
 * мог остаться от ошибочной chat-режим сборки dashboard-бандла, и чистит
 * закешированные им ресурсы. Без этого finance-страница зависала на
 * "Загрузка объектов…" — старый SW перехватывал fetch'и.
 */
type RegisterSWOptions = {
  immediate?: boolean;
  onNeedRefresh?: () => void;
  onRegisteredSW?: (swUrl: string, registration: ServiceWorkerRegistration | undefined) => void;
};

export function registerSW(_opts?: RegisterSWOptions): (reloadPage?: boolean) => Promise<void> {
  if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((regs) => {
        let killed = false;
        for (const r of regs) {
          r.unregister();
          killed = true;
        }
        if (killed && typeof caches !== "undefined") {
          caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
        }
      })
      .catch(() => { /* ignore */ });
  }
  return () => Promise.resolve();
}
